<template>
  <b-overlay :show="show" opacity="0.5" rounded="sm">
    <div>
      <customer-treatment-list-add-new
        v-model="isAddNewTreatmentSidebarActive"
        :is-treatment-handler-sidebar-active.sync="
          isAddNewTreatmentSidebarActive
        "
        :treatment="treatment"
        :clear-treatment-data="clearTreatmentData"
        @remove-treatment="removeTreatment"
        @add-treatment="addTreatment"
        @update-treatment="updateTreatment"
        :hauttyps="hauttyps"
        @refetch-data="refetchData"
        :mitarbeiters="mitarbeiters"
        :categories="categories"
        :allServices="allServices"
      />

      <!-- Table Container Card -->
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="
                d-flex
                align-items-center
                justify-content-start
                mb-1 mb-md-0
              "
            >
               <label>{{ $t("entries") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <b-button variant="primary" @click="onExport(kundeId)">
              {{ $t("Export") }}
            </b-button>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <!-- <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search...')"
                /> -->
                <b-button
                  variant="primary"
                  @click="isAddNewTreatmentSidebarActive = true"
                >
                  <span class="text-nowrap">{{$t("Add Treatment")}}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refTreatmentListTable"
          class="position-relative"
          :items="fetchCustomerTreatments"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('No matching records found')"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: Id -->
          <template #cell(id)="data">
            <b-link @click="editTreatment(data.item)" class="font-weight-bold">
              #{{ data.value }}
            </b-link>
          </template>

          <!-- Column: Behandlung -->
          <template #cell(behandlung)="data">
            {{ data.value }} <br />
            {{ resolveServiceName(data.value) }}
          </template>

          <!-- Column: mitarbeiterName -->
          <template #cell(mitarbeiter_id)="data">
            {{ resolveMitarbeiterName(data.value) }}
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="editTreatment(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t("Edit") }}</span>
              </b-dropdown-item>

              <b-dropdown-item @click="showMsgDeleteConfirm(data.item.id)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t("Delete") }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="
                d-flex
                align-items-center
                justify-content-center justify-content-sm-start
              "
            >
              <span class="text-muted"
                >{{ $t("Showing") }} {{ dataMeta.from }} {{ $t("to") }}
                {{ dataMeta.to }} {{ $t("von") }}
                {{ dataMeta.of }} entries</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="
                d-flex
                align-items-center
                justify-content-center justify-content-sm-end
              "
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalTreatments"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import { toRefs } from "@vue/composition-api";
import useCustomerTreatmentsList from "./useCustomerTreatmentsList";
import customerStoreModule from "../customerStoreModule";
import CustomerTreatmentListAddNew from "./CustomerTreatmentListAddNew.vue";
import employeeStoreModule from "../../employee/employeeStoreModule";
import _ from "lodash";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import i18n from "@/libs/i18n";
import axios from "@axios";
import serviceStoreModule from "../serviceStoreModule";

export default {
  components: {
    CustomerTreatmentListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ToastificationContent,
    BOverlay,
  },
  props: {
    mitarbeiterId: {
      type: Number,
      required: true,
    },
    kundeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  setup(props) {
    const CUSTOMER_STORE_MODULE_NAME = "app-customer";

    // Register module
    if (!store.hasModule(CUSTOMER_STORE_MODULE_NAME))
      store.registerModule(CUSTOMER_STORE_MODULE_NAME, customerStoreModule);

    const STAFF_STORE_MODULE_NAME = "app-employee";

    // Register module
    if (!store.hasModule(STAFF_STORE_MODULE_NAME))
      store.registerModule(STAFF_STORE_MODULE_NAME, employeeStoreModule);

    const SERVICE_STORE_MODULE_NAME = "app-service";

    // Register module
    if (!store.hasModule(SERVICE_STORE_MODULE_NAME))
      store.registerModule(SERVICE_STORE_MODULE_NAME, serviceStoreModule);

    // Unregister on leave
    onUnmounted(() => {
      if (store.hasModule(STAFF_STORE_MODULE_NAME))
        store.unregisterModule(STAFF_STORE_MODULE_NAME);

      if (store.hasModule(CUSTOMER_STORE_MODULE_NAME))
        store.unregisterModule(CUSTOMER_STORE_MODULE_NAME);

      if (store.hasModule(SERVICE_STORE_MODULE_NAME))
        store.unregisterModule(SERVICE_STORE_MODULE_NAME);
    });

    const mitarbeiters = ref([]);

    store.dispatch("app-employee/fetchEmployees", {}).then((response) => {
      const responseData = response.data;

      mitarbeiters.value = responseData.data;
    });

    const blankTreatment = {
      id: null,
      kunde_id: props.kundeId,
      mitarbeiter_id: null,
      category: "",
      behandlung: "",
      behandlungsdatum: "",
      bemerkung: "",
      durchmesser: null,
      energie: null,
      energiedichte: null,
      frequenz: null,
      hauttyp: null,
      preis: 0.0,
      rabatt_money: null,
      rabatt_percent: null,
      total_preis: 0,
    };
    const treatment = ref(JSON.parse(JSON.stringify(blankTreatment)));
    const clearTreatmentData = () => {
      treatment.value = JSON.parse(JSON.stringify(blankTreatment));
    };

    const isAddNewTreatmentSidebarActive = ref(false);

    const hauttyps = [
      { label: "Hauttyp I", value: "1" },
      { label: "Hauttyp II", value: "2" },
      { label: "Hauttyp III", value: "3" },
      { label: "Hauttyp IV", value: "4" },
      { label: "Hauttyp V", value: "5" },
      { label: "Hauttyp VI", value: "6" },
    ];

    const categories = ref([]);

    store
      .dispatch("app-service/fetchCategories", {})
      .then((response) => {
        categories.value = response.data.categories;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          categories.value = [];
        }
      });

    const allServices = ref([]);
    store
      .dispatch("app-service/fetchServices", {})
      .then((response) => {
        allServices.value = response.data.services;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          allServices.value = [];
        }
      });

    const editTreatment = (treatmentData) => {
      treatment.value = treatmentData;
      var service = _.filter(
        allServices.value,
        (service) => service.ID == treatmentData.behandlung
      )[0];

      treatment.value.category = service.Category;
      isAddNewTreatmentSidebarActive.value = true;
    };

    const {
      fetchCustomerTreatments,
      tableColumns,
      perPage,
      currentPage,
      totalTreatments,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTreatmentListTable,
      refetchData,
      resolveServiceName,
      resolveMitarbeiterName
    } = useCustomerTreatmentsList(toRefs(props), allServices, mitarbeiters);

    return {
      // Sidebar
      isAddNewTreatmentSidebarActive,
      treatment,
      clearTreatmentData,
      fetchCustomerTreatments,
      tableColumns,
      perPage,
      currentPage,
      totalTreatments,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTreatmentListTable,
      refetchData,
      hauttyps,
      mitarbeiters,
      categories,
      allServices,
      editTreatment,
      resolveServiceName,
      resolveMitarbeiterName
    };
  },
  methods: {
    onExport() {
      var vm = this;

      axios({
        url: `/behandlung/export?kunde_id=` +vm.kundeId,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        const [, filename] =
          response.headers["content-disposition"].split("filename=");
        fileLink.setAttribute("download", filename);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    addTreatment(val) {
      this.show = !this.show;
      store.dispatch("app-customer/addTreatment", val).then(() => {
        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("Added"),
            icon: "EditIcon",
            variant: "success",
          },
        });
        this.refetchData();
        this.show = !this.show;
      });
    },
    removeTreatment() {
      this.show = !this.show;
      store
        .dispatch("app-customer/removeTreatment", { id: task.value.id })
        .then(() => {
          // eslint-disable-next-line no-use-before-define
          this.$toast({
            component: ToastificationContent,
            props: {
              title: i18n.t("Deleted"),
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.refetchData();
          this.show = !this.show;
        });
    },
    updateTreatment(treatmentData) {
      this.show = !this.show;
      store.dispatch("app-customer/updateTreatment", treatmentData).then(() => {
        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: i18n.t("Updated"),
            icon: "EditIcon",
            variant: "success",
          },
        });
        this.refetchData();
        this.show = !this.show;
      });
    },
    showMsgDeleteConfirm(treatmentId) {
      var vm = this;

      this.$bvModal
        .msgBoxConfirm(
          i18n.t("Are you sure you want to delete this treatment?"),
          {
            title: i18n.t("Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: i18n.t("Yes"),
            cancelTitle: i18n.t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            store
              .dispatch("app-customer/removeTreatment", { id: treatmentId })
              .then(() => {
                vm.refetchData();

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: i18n.t("Deleted"),
                    icon: "TrashIcon",
                    variant: "success",
                  },
                });
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
